export default __webpack_public_path__ + "robot-recommend.svg";